import fetch from 'isomorphic-fetch';
import utmUtils from '../utils/utmUtils';
import storeUtils from '../utils/storeUtils';
import qs from 'query-string';
import shareUtils from '../utils/shareUtils';

const blogDao = {
  buildQs: (params = {}) => '?' + qs.stringify(params),
  listPosts: async ({languageType = 'enu', pageIndex = 1, pageSize = 20}) => {
    try {
      const response = await fetch(
        `/smb-frontend/blog/post/list-posts.action?languageType=${languageType}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
        {
          method: 'GET',
        }
      );
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listAllPosts: async params => {
    const pageSize = 20;
    let pageIndex = 1;
    let results = [];
    while (true) {
      const json = await blogDao.listPosts({...params, pageIndex, pageSize});
      const r = json.results || json;
      results = results.concat(r);
      if (r.length < pageSize) break;
      pageIndex++;
    }
    return results;
  },
  getListPostDisplayLink: (languageType = 'enu', attr) =>
    `/smb-frontend/blog/post/list-post-display.action?languageType=${languageType}&attr=${attr}`,
  listPostDisplay: async (languageType = 'enu', attr) => {
    try {
      const response = await fetch(
        `/smb-frontend/blog/post/list-post-display.action?languageType=${languageType}&attr=${attr}`,
        {
          method: 'GET',
        }
      );
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  queryPost: async postId => {
    const url = `/smb-frontend/blog/post/query-post.action?postId=${postId}`;
    if (window.snapStore && window.snapStore[url]) return window.snapStore[url];

    const response = await fetch(url, {
      method: 'GET',
    });
    if (response.ok) {
      return response.json();
    }
    return [];
  },
  queryPostByPostHandle: async (
    postHandle,
    languageType = 'enu',
    excludePostContent = false
  ) => {
    const url = `/smb-frontend/blog/post/query-post-by-key.action?postHandle=${postHandle}&languageType=${languageType}${
      excludePostContent ? '&excludePostContent=true' : ''
    }`;
    if (window.snapStore && window.snapStore[url]) return window.snapStore[url];
    const response = await fetch(url, {
      method: 'GET',
    });
    if (response.ok) {
      return response.json();
    }
    return [];
  },
  queryPostByMappingKey: async (mappingKey, languageType = 'enu') => {
    const response = await fetch(
      `/smb-frontend/blog/post/query-post-by-mapping-key.action?mappingKey=${mappingKey}&languageType=${languageType}&simple=`,
      {
        method: 'GET',
      }
    );
    if (response.ok) {
      return response.json();
    }
    return null;
  },
  listPostsByAuthor: async ({
    authorId,
    authorHandle,
    languageType = 'enu',
    postAttr,
    pageIndex,
    pageSize,
  }) => {
    const response = await fetch(
      `/smb-frontend/blog/post/list-posts-by-author.action?authorId=${authorId}&languageType=${languageType}&postAttr=${postAttr}&authorHandle=${authorHandle}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {
        method: 'GET',
      }
    );
    if (response.ok) {
      return response.json();
    }
    return [];
  },
  listAllPostsByAuthor: async params => {
    const pageSize = params.pageSize || 20;
    let pageIndex = params.pageIndex || 1;
    let results = [];
    while (true) {
      const json = await blogDao.listPostsByAuthor({
        ...params,
        pageIndex,
        pageSize,
      });
      const r = json.results || json;
      results = results.concat(r);
      if (r.length < pageSize) break;
      pageIndex++;
    }
    return results;
  },
  searchPosts: async ({
    keyword,
    languageType = 'enu',
    pageIndex = 1,
    pageSize,
  }) => {
    try {
      const response = await fetch(
        `/smb-frontend/blog/post/search-post.action?keyword=${keyword}&languageType=${languageType}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
        {method: 'GET'}
      );
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listPostsByFilter: async ({
    languageType,
    attrs,
    pageIndex,
    pageSize,
    isSearch = false,
    category = '',
  }) => {
    try {
      const response = await fetch(
        `/smb-frontend/blog/post/list-posts-by-filters.action`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            languageType,
            attrs,
            pageIndex,
            pageSize,
            isSearch,
            category,
          }),
        }
      );
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listFilter: async param => {
    try {
      const response = await fetch(
        `/smb-frontend/blog/post/list-filters.action`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(param),
        }
      );
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listBlogHeadings: async ({
    languageType,
    postAttr,
    appType = '',
    method = 'POST',
  }) => {
    const url = `/smb-frontend/blog/post/list-headings-by-post-attr.action?languageType=${languageType}&postAttr=${postAttr}&appType=${appType}`;
    if (window.snapStore && window.snapStore[url]) return window.snapStore[url];
    try {
      if (method === 'POST') {
        const response = await fetch(
          `/smb-frontend/blog/post/list-headings-by-post-attr.action`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({languageType, postAttr, appType}),
          }
        );
        if (response.ok) {
          return response.json();
        }
      } else {
        const response = await fetch(url);
        if (response.ok) {
          return response.json();
        }
      }

      return [];
    } catch (e) {
      return [];
    }
  },
  createSupportRequest: async support => {
    const sourceUtm = utmUtils.getSupportSourceUtm();
    const refUrlFirst = storeUtils.getFirstUrlSource();
    const refUrlLast = storeUtils.getLastUrlSource();
    const response = await fetch(
      `/smb-frontend/support/create-request.action`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          support: {...support, sourceUtm, refUrlFirst, refUrlLast},
        }),
      }
    );
    if (response.ok) return await response.json();
    return Promise.reject({
      status: response.status,
      statusText: response.statusText,
    });
  },
  getStrapiBannerByVuid: async ({vuid, getAfterContent}) => {
    const url = `/smb-frontend/strapi/query-content-by-vuid.action?vuid=${vuid}&type=BANNER${getAfterContent}`;
    if (window.snapStore && window.snapStore[url]) return window.snapStore[url];
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      return await response.json();
    } catch (e) {
      return [];
    }
  },
  listTopicsByLang: async params => {
    try {
      const url =
        `/smb-frontend/blog/topic/list-topics-by-language.action` +
        blogDao.buildQs(params);
      const snapStoreValue = shareUtils.getSnapStoreValue(url);
      if (snapStoreValue) return snapStoreValue;
      const response = await fetch(url, {
        method: 'GET',
      });
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listPostByTopics: async ({languageType, topics}) => {
    try {
      const url =
        `/smb-frontend/blog/post/list-posts-by-topics.action` +
        blogDao.buildQs({
          languageType,
          topics,
        });
      const snapStoreValue = shareUtils.getSnapStoreValue(url);
      if (snapStoreValue) return snapStoreValue;
      const response = await fetch(url, {
        method: 'GET',
      });
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
  listDeadLinkBlackLists: async () => {
    try {
      const url = `/smb-frontend/blog/post/list-dead-link-blacklists.action`;
      const snapStoreValue = shareUtils.getSnapStoreValue(url);
      if (snapStoreValue) return snapStoreValue;
      const response = await fetch(url, {
        method: 'GET',
      });
      if (response.ok) {
        return response.json();
      }
      return [];
    } catch (e) {
      return [];
    }
  },
};

export default blogDao;
